import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import TextField from 'src/components/TextField';
import { useTranslation } from 'react-i18next';
import s from './ColumnFilters.styles';

const ColumnFilterText = ({ value, onChange, onRemove, column: { label } }) => {
  const { t } = useTranslation();
  const [popupActive, setPopupActive] = useState(false);

  const ref = useRef(null);
  useEffect(() => {
    const handleClickOutside = e => {
      if (ref.current && !ref.current.contains(e.target)) {
        setPopupActive(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);

  const [localValue, setLocalValue] = useState(value[0] || '');

  const onSubmit = () => {
    onChange([localValue]);
    setPopupActive(false);
  };

  return (
    <s.FilterWrapper>
      <s.FilterLabel changed={!!value[0]} onClick={() => setPopupActive(true)}>
        <s.FilterRemoveBtn name="cross" onClick={onRemove} />
        {label}: {value[0] || t('ALL')}
      </s.FilterLabel>
      {popupActive && (
        <s.MorePopup ref={ref}>
          <s.PopupTextField>
            <TextField
              onChange={e => setLocalValue(e.target.value)}
              onKeyUp={e => e.keyCode === 13 && onSubmit()}
              placeholder={t('FILTER_BY_STRING')}
              value={localValue}
            />
            {localValue ? (
              <s.TextConfirmButton onClick={onSubmit}>
                <s.MoreSearchIcon check name="check" />
              </s.TextConfirmButton>
            ) : (
              <s.MoreSearchIcon funnel name="funnel" />
            )}
          </s.PopupTextField>
        </s.MorePopup>
      )}
    </s.FilterWrapper>
  );
};

ColumnFilterText.propTypes = {
  column: PropTypes.shape({
    label: PropTypes.string,
  }),
  onChange: PropTypes.func,
  onRemove: PropTypes.func,
  value: PropTypes.arrayOf(PropTypes.string),
};

export default React.memo(ColumnFilterText);
